import { render, staticRenderFns } from "./BrowseGoalsWizardModal.vue?vue&type=template&id=6e3d3380&scoped=true"
import script from "./BrowseGoalsWizardModal.vue?vue&type=script&lang=js"
export * from "./BrowseGoalsWizardModal.vue?vue&type=script&lang=js"
import style0 from "./BrowseGoalsWizardModal.vue?vue&type=style&index=0&id=6e3d3380&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3d3380",
  null
  
)

export default component.exports